export const CUSTOMER_SOURCES = [
  { value: "searching", text: "วิ่งงาน" },
  { value: "walkin", text: "Walk in" },
  { value: "email", text: "E-mail" },
  { value: "advertise", text: "ป้ายโฆษณา" },
  { value: "facebook", text: "Online - Facebook" },
  { value: "tiktok", text: "Online - Tiktok" },
  { value: "website", text: "Online - Website" },
  { value: "youtube", text: "Online - Youtube" },
  { value: "reference", text: "มีคนแนะนำมา" },
  { value: "bni", text: "BNI" }
]

export const CUSTOMER_SOURCE_VALUES = CUSTOMER_SOURCES.map((item) => item.value)

export const CUSTOMER_SOURCE_LABELS = CUSTOMER_SOURCES.reduce((acc, item) => {
  acc[item.value] = item.text
  return acc
}, {})
